define('GiftWrap.Helper', [
    'Product.Model',
    'Transaction.Line.Model',

    'product_views_option_giftwrap.tpl',
    'transaction_line_views_selected_option_giftwrap.tpl',
    'product_views_option_hidden.tpl',
    'transaction_line_views_hidden_option.tpl',

    'SC.Configuration',
    'Handlebars',
    'HandlebarsExtras',
    'underscore',
    'Utils'
], function GiftWrapHelper(
    ProductModel,
    TransactionLineModel,

    productViewsOptionGiftwrapTpl,
    productViewsSelectedOptionGiftwrapTpl,
    productViewsOptionHiddenTpl,
    productViewsSelectedOptionHiddenTpl,

    Configuration,
    Handlebars,
    HandlebarsExtras,
    _
) {
    'use strict';

    // @deprecated We are going to use the default behavior, showing the image associated to the Gift Wrap item record.
    // var getThumbnail = function getThumbnail(fn) {
    //     var item = this.get('item');
    //
    //     if (item.get('internalid') === Configuration.customizations.giftWrap.giftWrapItem) {
    //         return {
    //             url: Handlebars.helpers.getThemeAssetsPath(Configuration.customizations.giftWrap.giftWrapImg),
    //             altimagetext: 'Gift Wrap'
    //         };
    //     }
    //     return fn.apply(this, _(arguments).toArray().slice(1));
    // };
    //
    // _(ProductModel.prototype).extend({
    //     getThumbnail: _(ProductModel.prototype.getThumbnail).wrap(getThumbnail)
    // });
    //
    // _(TransactionLineModel.prototype).extend({
    //     getThumbnail: _(TransactionLineModel.prototype.getThumbnail).wrap(getThumbnail)
    // });

    return {
        configure: function configure() {
            var itemGiftWrapOption = _(Configuration.ItemOptions.optionsConfiguration).findWhere({
                cartOptionId: 'custcol_gift_wrap'
            });
            var itemGiftLineOption = _(Configuration.ItemOptions.optionsConfiguration).findWhere({
                cartOptionId: 'custcol_giftwrap_line_id'
            });

            itemGiftWrapOption.templates = {
                selector: productViewsOptionGiftwrapTpl,
                selected: productViewsSelectedOptionGiftwrapTpl
            };

            itemGiftLineOption.templates = {
                selector: productViewsOptionHiddenTpl,
                selected: productViewsSelectedOptionHiddenTpl
            };

            Configuration.itemKeyMapping = _(Configuration.itemKeyMapping || {}).extend({
                _isGiftwrappable: 'custitem_gift_wrap_indicator'
            });
        }
    };
});

